export enum ConflictError {
	GroupAlreadyExists = 'Group already exists at path',
}
